module.exports = __webpack_public_path__ + "static/img/view-02-sub@m.b947c52.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ket/view-02-sub@m.jpg
// module id = +Nt8
// module chunks = 0